import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../user/auth.service';
import { Routes } from 'src/app/constants/routes.constant';

@Injectable()
export class AuthGuardService  {

  constructor(
    public authService: AuthService, 
    public router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): boolean {

    if (!this.authService.isLoggedIn()) {
      // this.router.navigate([Routes.GUEST.SIGN]);
      if(window.location.href.includes('choose-slots') == true){
        this.router.navigate(['/welcome'], { queryParams: { returnUrl: state.url }});
      }else{
      this.router.navigate([Routes.GUEST.SIGN_IN], { queryParams: { returnUrl: state.url }});
      }
      return false;
    }
    
    return true;
  }
}
